import { createContext } from "react";

export const CacheContext = createContext({});
